// Shared constants and helpers for activity add-ons: transportation & accommodation.

export const TRANSPORT_OPTIONS = [
    { value: "one_way", label: "One-way" },
    { value: "return", label: "Return trip" },
    { value: "two_way", label: "Two-way" },
];

export const TRANSPORT_LABEL = Object.fromEntries(
    TRANSPORT_OPTIONS.map(o => [o.value, o.label]),
);

// "YYYY-MM-DD" -> local Date at 00:00 (avoids TZ shifting the date)
export function parseDate(str) {
    if (!str) return null;
    const [y, m, d] = str.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}

// Date -> "YYYY-MM-DD"
export function formatDate(d) {
    const pad = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Pretty label for a "YYYY-MM-DD" string, e.g. "Fri, Jun 5"
export function prettyDate(str) {
    const d = parseDate(str);
    if (!d) return str;
    return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}
